export const phoneValidator = (value) => {
  return /^(?:\(?([1-9][0-9])\)?\s?)?(?:((9\d|[2-9])\d{3})-?(\d{4}))$/.test(value)
}
